"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
const CloseWhiteIcon = (props) => {
    return (react_1.default.createElement(react_native_svg_1.default, Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, null,
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.Path, { fill: "#FFF", fillOpacity: 0, d: "M0 0H32V32H0z", transform: "translate(-327.000000, -47.000000) translate(323.000000, 43.000000)" }),
                    react_1.default.createElement(react_native_svg_1.G, { stroke: "#FFF", strokeLinecap: "square" },
                        react_1.default.createElement(react_native_svg_1.Path, { d: "M12.6.6l-12 12m12 0L.6.6", transform: "translate(-327.000000, -47.000000) translate(323.000000, 43.000000) translate(9.425000, 9.425000)" })))))));
};
exports.default = react_1.default.memo(CloseWhiteIcon);
